import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';
import { NotificationService } from '../../services/notification.service';
import { ApiService } from '../../services/api.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-whatsapp-consent',
  templateUrl: './whatsapp-consent.component.html',
  styleUrls: ['./whatsapp-consent.component.scss'],
})
export class WhatsAppConsentComponent {
  whatsappConsent: boolean = false;
  userId: string = '';

  constructor(
    private apiService: ApiService,
    private http: HttpClient,
    private router: Router,
    private storageService: StorageService,
    private notify: NotificationService,
    private user: UserService,
  ) {
    this.userId = this.getUserId();
  }

  onConsentChange(event: any): void {
    this.whatsappConsent = event.target.checked;
  }

  continue(): void {
    if (this.whatsappConsent) {
      this.sendConsentToAPI(true);
    }
  }

  skip(): void {
    this.sendConsentToAPI(false);
  }

  private sendConsentToAPI(consent: boolean): void {
    const payload = {
      userId: this.userId,
      whatsappConsent: consent,
    };

    // Replace with your actual API endpoint
    this.apiService.post('retailers/saveWhatsappConsent', payload).subscribe({
      next: (response) => {

        if (response.code === 1) {
          this.storageService.set({
            getWAConsentByUser: true,
          });

          this.navigateNext();
        } else if (response.message === 'Invalid APIKEY') {
          this.notify.showWarning(
            'Your session has expired. Please login again.',
            'Session Expired'
          );
          this.apiService.get('retailers/logout').subscribe({
            complete: () => {
              this.storageService.clearStore();
              this.user.reset();
              this.router.navigate(['/login']);
            },
          });
          
        } else {
          this.notify.showError(response.message, '');
        }
      },
      error: (error) => {
        this.notify.showError('Failed to update consent.', '');
      },
    });
  }

  private getUserId(): string {
    // Get userId from StorageService
    const userId = this.storageService.get('userId');

    if (!userId) {
      console.warn('UserId not found in storage');
      this.notify.showError('Failed to retrieve user ID.', '');
      this.router.navigate(['/login']);
      return '';
    }

    return userId;
  }

  private navigateNext(): void {
    this.router.navigate(['/dashboard']);
  }
}
